import React, { useEffect, useState } from 'react';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { PlusCircleIcon } from '@primer/octicons-react';
import JobsTable from './JobsTable';
import { Badge, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import CogenTable from '../../table';
import { ReqGet, ReqPost } from '../../../config/Requests';
import { toast } from 'react-toastify';
import ConfirmationDialog from '../../common/confirmationDialog';
import OverlayLoader from '../../common/OverlayLoder';
import JobFilledModal from '../../job/JobFilledModal';

function JobOpportunity({ _handleAddNewJob, dataType, setKey }) {
	const [memberSelected, setMemberSelected] = useState([]);
	const [loading, setLoading] = useState(false);
	const [processLoading, setProcessLaoding] = useState(false);
	const [publishedJobs, setPublishedJobs] = useState([]);
	const [jobId, setJobId] = useState('');
	const [jobAction, setJobAction] = useState('');
	const [memberSelection, setMemberSelection] = useState([]);
	const [confirmationDialog, setConfirmationDialog] = useState(false);
	const [filledModal, setFilledModal] = useState(false);

	const fetchPublishedJobs = async () => {
		try {
			setLoading(true);
			const { data } = await ReqGet('jobs');
			setPublishedJobs(data.data);
		} catch (error) {
			toast.error(
				error?.response?.data?.message || 'Failed to fetch published jobs'
			);
		} finally {
			setLoading(false);
		}
	};

	const filledJobHandler = id => {
		ReqGet(`jobs/${id}`)
			.then(({ data }) => {
				if (data) {
					setMemberSelection(
						data?.data?.members_applied_and_not_reject_or_decline
					);
				}
			})
			.catch(err => {
				toast.error('Failed to get specific job');
			})
			.finally(err => {
				setProcessLaoding(false);
				setFilledModal(true);
			});
	};

	const cancelJobApi = jobId => {
		ReqPost(`cancel/job/${jobId}`)
			.then(res => {
				if (res.status === 200) {
					toast.success('Job has been Canceled Successfully');
					getJobs();
				}
			})
			.catch(err => {
				toast.error(err?.response?.data?.message || 'Failed to Cancel Job');
			})
			.finally(err => {
				setProcessLaoding(false);
			});
	};

	const pauseJobApi = jobId => {
		ReqPost(`pause/job/${jobId}`)
			.then(res => {
				if (res.status === 200) {
					toast.success('Job has been Paused Successfully');
					getJobs();
				}
			})
			.catch(err => {
				toast.error(err?.response?.data?.message || 'Failed to Puase Job');
			})
			.finally(err => {
				setProcessLaoding(false);
			});
	};

	const getJobs = () => {
		setLoading(true);
		ReqGet('jobs')
			.then(res => {
				setPublishedJobs(res.data.data);
			})
			.catch(err => {
				toast.error(err?.response?.data?.message || 'Failed to get jobs');
			})
			.finally(err => {
				setLoading(false);
			});
	};

	const handleYes = () => {
		if (!jobId) return toast.info('Please provide the job id ');
		setConfirmationDialog(false);
		setProcessLaoding(true);

		if (jobAction === 'pause') return pauseJobApi(jobId);
		if (jobAction === 'cancel') return cancelJobApi(jobId);
	};

	const jobActionHandler = (id, action) => {
		setJobId(id);
		setJobAction(action);

		if (action === 'fill') {
			setProcessLaoding(true);
			filledJobHandler(id);
		} else {
			setConfirmationDialog(true);
		}
	};

	const getDialogTitle = () => {
		if (jobAction === 'pause') return 'Pause Job';
		if (jobAction === 'cancel') return 'Cancel Job';
	};

	const memberSelectionFun = e => {
		const { value, checked } = e.target;
		if (!checked)
			return setMemberSelected(memberSelected.filter(d1 => d1 != value));
		setMemberSelected([...memberSelected, e.target.value]);
	};

	const filledJobApi = () => {
		if (memberSelected?.length < 1) {
			return toast.info('Please select atleast 1 member to fill job');
		}

		ReqPost(`filled/job/${jobId}`, { selected_applicants: memberSelected })
			.then(res => {
				if (res.status === 200) {
					toast.success('Job Filled succesfully');
					getJobs();
				}
			})
			.catch(err => {
				toast.error('Failed to Filled this job');
			})
			.finally(err => {
				setFilledModal(false);
			});
	};

	useEffect(() => {
		fetchPublishedJobs();
	}, []);

	return (
		<Container fluid className='mt-4'>
			<Row>
				<Col>
					<CogenTable
						data={publishedJobs}
						dataType={'Publish'}
						isLoading={loading}
						pauseJobHandler={id => jobActionHandler(id, 'pause')}
						filledJobHandler={id => jobActionHandler(id, 'fill')}
						cancelJobHandler={id => jobActionHandler(id, 'cancel')}
					/>
					<ConfirmationDialog
						setOpen={setConfirmationDialog}
						open={confirmationDialog}
						dialogTitle={getDialogTitle()}
						contentText={`Are you sure you want to ${jobAction} job?`}
						onYes={handleYes}
					/>

					<JobFilledModal
						memberSelection={memberSelection}
						memberSelectionFun={memberSelectionFun}
						filledJob={filledJobApi}
						setOpen={setFilledModal}
						open={filledModal}
					/>

					{/* <JobsTable
						setKey={setKey}
						dataType={dataType}
						jobActionHandler={jobActionHandler}
						filledJobHandler={filledJobHandler}
						cancelJobHandler={cancelJobHandler}
						data={publishedJobs}
					></JobsTable> */}
				</Col>
			</Row>
			<OverlayLoader open={processLoading} />
		</Container>
	);
}

export default JobOpportunity;
